import React, { useState, useEffect } from 'react';
import Page from 'src/components/Page';
import {
  Alert,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  Modal,
  Pagination,
  PaginationItem,
  Paper,
  Radio,
  RadioGroup,
  Snackbar,
  Stack,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import {
  LoadingButton,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineSeparator,
  Timeline
} from '@mui/lab';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import Iconify from 'src/components/Iconify';
import { useLocation, useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import Messagebox from 'src/components/home/Messagebox';
import { api } from 'src/Api';

export default function Message() {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  const userData = JSON.parse(user);
  const { service_id, service_name, sub_service_id, sub_service_name, customer_id } =
    location.state || {};
  console.log('🚀 ~ Message ~ sub_service_id:', sub_service_id);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [message, setMessage] = useState('');
  const [loading, setloading] = useState(false);
  const [openCommunication, setopenCommunication] = useState(false);
  const [isGetMessage, setisGetMessage] = useState(false);

  const handleSubmit = () => {
    setloading(true);
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formData = new FormData();
    service_id && formData.append('service_id', service_id);
    formData.append('sub_service_id', sub_service_id);
    formData.append('customer_service_id', customer_id);
    formData.append('message', message);

    fetch(api.send_service_message, {
      headers: myHeaders,
      body: formData,
      method: 'POST'
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          closeCommunicationModal();
          setisGetMessage(true);
          setTimeout(() => {
            handleSnackbarClose();
          }, 2000);
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('error');
          setTimeout(() => {
            handleSnackbarClose();
          }, 2000);
        }
        setloading(false);
      })
      .catch((error) => {
        console.log('Fetch error:', error);
        setloading(false);
      })
      .finally(() => setloading(false));
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  function openCommunicationModal() {
    setopenCommunication(true);
  }

  const closeCommunicationModal = () => {
    setopenCommunication(false);
    setMessage('');
    setisGetMessage(false);
  };

  return (
    <Page title={`Message | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center">
            <IconButton
              style={{
                marginRight: 12,
                height: 40,
                width: 70,
                borderRadius: 5,
                backgroundColor: 'rgba(249, 0, 1,0.1)'
              }}
              onClick={() => navigate(-1)}
            >
              <Iconify icon="ion:return-up-back" style={{ fontSize: 25, color: '#f90001' }} />
            </IconButton>

            <Typography variant="h4" sx={{ color: '#f90001' }}>
              Message
            </Typography>
          </Stack>

          <Stack>
            <Button
              variant="contained"
              sx={{ alignSelf: 'end', fontSize: 11 }}
              onClick={openCommunicationModal}
            >
              Add Message
            </Button>
          </Stack>
        </Stack>

        <Modal
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%'
          }}
          open={openCommunication}
          onClose={closeCommunicationModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              maxWidth: '60%',
              maxHeight: '90%',
              bgcolor: 'background.paper',
              boxShadow: 24,
              overflow: 'auto',
              p: 1,
              border: '2px solid',
              borderColor: 'primary.main',
              flex: 1
            }}
            className="admin_modal_pa"
          >
            <Box
              sx={{
                width: '100%',
                bgcolor: 'background.paper',
                p: 2
              }}
            >
              <Box display={'flex'} justifyContent={'space-between'} pb={1} alignItems="center">
                <Typography
                  variant="h6"
                  style={{ fontWeight: 'bold', textAlign: 'center', color: '#f90001' }}
                >
                  Send Message
                </Typography>
                <IconButton onClick={closeCommunicationModal} edge="end">
                  <CloseIcon />
                </IconButton>
              </Box>
              <TextField
                fullWidth
                multiline
                rows={4}
                label="Message"
                variant="outlined"
                name="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
              <Grid mb={-2} xs={12} display={'flex'} justifyContent={'flex-end'} mt={2}>
                <LoadingButton
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  loading={loading}
                >
                  {'Send'}
                </LoadingButton>
              </Grid>
            </Box>
          </Box>
        </Modal>

        <Messagebox customer_id={customer_id} getMessage={isGetMessage} />

        <Snackbar open={snackbarOpen} autoHideDuration={4000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container>
    </Page>
  );
}
